import type { TickerSnapshot } from "./types";

/**
 * Fetch the ticker snapshot from the shared backend. The backend only ever
 * serves cache, so this is always cheap and never touches third-party APIs.
 */
export async function fetchSnapshot(apiBase: string): Promise<TickerSnapshot> {
  const base = apiBase.replace(/\/+$/, "");
  const res = await fetch(`${base}/api/ticker`, {
    headers: { accept: "application/json" },
    // Let the browser/CDN honor the backend's Cache-Control.
    cache: "default",
  });
  if (!res.ok) throw new Error(`ticker HTTP ${res.status}`);
  const data = (await res.json()) as TickerSnapshot;
  if (!data || !Array.isArray(data.matches)) {
    throw new Error("malformed ticker payload");
  }
  return data;
}
